import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Grid,
  Typography,
  Divider,
} from "@mui/material";
import WizardCardHeader from "./CardHeader";
import CardQuestion from "./CardQuestion";
import WizardFooter from "./WizardFooter";
import { observer } from "mobx-react-lite";
import { useCustDiagStore } from "../../contexts/RootStoreProvider";
import DiagnosisJourney from "./DiagnosisJourney";
import ResolutionForm from "./ResolutionForm";
import { Logo } from "../Logo";
import WizardHeader from "./WizardHeader";

const Wizard = (props: any) => {
  const custDiagStore = useCustDiagStore();

  const style = { backgroundColor: "#001f3d", color: "white" };

  return (
    <Grid container justifyContent={"center"} style={style}>
      <WizardHeader title={""} />
      <Card style={style}>
        <CardContent>
          {custDiagStore.currentDiagnosticStep?.type === "q" ? (
            <>
              <WizardCardHeader
                diagStep={custDiagStore.currentDiagnosticStep}
              />
              <CardQuestion diagStep={custDiagStore.currentDiagnosticStep} />
            </>
          ) : (
            <ResolutionForm />
          )}
        </CardContent>
        <CardActions disableSpacing>
          <WizardFooter />
          {/* <Button size="small">Start Over</Button>
        <Button size="small">Exit</Button> */}
        </CardActions>
      </Card>

      {/* <DiagnosisJourney /> */}
    </Grid>
  );
};

Wizard.propTypes = {
  diagnosticStep: PropTypes.number,
};

export default observer(Wizard);
